/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { OauthOpenAthensDeepLinkOptions, OauthOpenAthensDeepLinkResponses } from '../../models/OauthOpenAthensDeepLink'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Provide a redirect url for initiating deep-link handling through OpenAthens.
 * @summary Open Athens Deep Link
 * {@link /oauth/open_athens/deep-link}
 */
export function oauthOpenAthensDeepLink<ThrowOnError extends boolean = true>(options: Options<OauthOpenAthensDeepLinkOptions, ThrowOnError>): Promise<UnwrappedResult<OauthOpenAthensDeepLinkResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/oauth/open_athens/deep-link', ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<OauthOpenAthensDeepLinkResponses, ThrowOnError>>
}
